export default __webpack_public_path__ + "static/media/step3-min.e582e294.webp";